/** @format */
import LogoLucma from '../assets/img/LogoTextoNegro.svg';
import LogoSlide from '../assets/img/LogoTextoBlanco.svg';
console.log('URL BASE', process.env);
function Constantes() {
  const dataUser = JSON.parse(localStorage.getItem('userLogin'));
  const headers = {
    Authorization: dataUser == null ? '' : dataUser.detail.Security.Token,
  };
  let data = {
    Imagen: {
      LogoWeb: LogoLucma,
      LogoMovil: LogoSlide,
    },
    ApiConfig: {
      // URL_upnCore: "https://apiupn-dev.upn.edu.pe/portal-padres/",
      //URL_upnDevCore: "https://ytxbtzl9mc.execute-api.us-east-1.amazonaws.com/dev/Moofwd/",

      headers: headers,
      PATH_Attendance: 'Attendance/StudentAttendance/',
      PATH_Courses: 'Courses/StudentCourses/',
      PATH_Users: 'Users/ListStudentForAttorney/',
      PATH_HistoryAcademic: 'HistoryAcademic/HistoricCourses/',
      PATH_Schedule: 'Schedule/WeeklySchedule/',
      PATH_Ratings: 'Ratings/StudentGrades/',
      PATH_FinancesPaid: 'Finances/FinancesPaid/',
      PATH_FinancesVisaSync: 'Finances/FinancesVisaSync/',
      PATH_FinancesDebts: 'Finances/FinancesDebts/',
      PATH_LoginAttorney: 'Users/LoginAttorney',
      PATH_MFA: 'Users/MFA',
      PATH_GetUbigeoValue: 'Users/GetUbigeoValue',
      PATH_UpdateProfileAttorney: 'Users/UpdateProfileAttorney',
      PATH_GetEmailAttorneyForDni: 'Users/GetEmailAttorneyForDni/',
      PATH_UpdatePasswordAttorney: 'Users/UpdatePasswordAttorney',
      PATH_ValidateToken: 'Users/ValidateTokenRecoverPassword',
      PATH_SendMailCredencial: 'Users/SendMailCredencial',
    },
    //Localhost: "http://localhost:3000/Login",
    //Localhost: "https://dguj5saut2r2n.cloudfront.net/Login",
    Localhost: process.env.REACT_APP_SERVER_URL_UPNHOSTBASE,
    login: './login',
    SendMail: 'Se envío la confirmación a su cuenta de correo.',
    SeccionExpirada: 'Seccion expirada favor ingresar nuevamente.!',
    SeccionDistrito: 'Favor de seleccionar distrito.!',
    SeccionDepartamento: 'Favor de seleccionar departamento.!',
    SeccionProvincia: 'Favor de seleccionar provincia.!',
    noRegistros: 'No se encontró registros del usuario.',
    noMail: 'No envío ningún correo.',
    noDNI: `<div class="mb-2 card-parrafo-DNI">En caso no cuentes con tu usuario y clave, envíanos un correo a <a href="mailto:claveapoderados@upn.edu.pe">claveapoderados@upn.edu.pe</a> adjuntando los siguientes datos y tu DNI escaneado o en foto, para la atención de tu solicitud:</div>
    <div class="card-title-notas"><div>Nombre y apellido del estudiante</div>
    <div>Código de estudiante (comienza con Nxxxxxxxx)</div>
    <div>Nombre y apellido del apoderado</div>
    <div>DNI del apoderado</div>
    <div>Teléfono de contacto</div>
    <div>Correo de apoderado</div></div>`,
    msmCurso: 'No se encontró registros de cursos.',
    msmAcademico: 'No se encontró registros de historial académico',
    msmNotas: 'No se encontró registros de notas.',
    msmPagar: 'No se encontró registros en obligaciones a pagar.',
    msmSincronizar: 'No se encontró registros en pagos por sincronizar.',
    msmObligaciones: 'No se encontró registros en obligaciones pagadas.',
    msmAsistencias: 'No se encontró registros de asistencias.',
    msmEstudiante: 'No se encontró registros de estudiante.',
    msmUbigeo: 'No se encontró registros de ubigeo.',
    msmNoGuardo: 'No se guardo el registros.',
    msmGuardo: 'Se guardo correctamente el registros.',
    Version: 'V 1.2.7',
  };
  return data;
}
export default Constantes;
